/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { APPROVAL_STATUS } from "../../utils/enums";

type props = {
  data: any;
};

const ProfileTop = ({ data }: props) => {
  return (
    <>
      <div className="cards profile_top">
        <div className="gap_p">
          <div className="left_s">
            <div className="profile_image">
              <figure>
                <img
                  src={data?.image || "/static/images/user_placeholder.png"}
                  alt="Profile"
                />
                {/* {data?.status === APPROVAL_STATUS.APPROVED ? ( */}
                <span>
                  <img src="/static/images/verified_icon.svg" alt="Icon" />
                </span>
                {/* ) : null} */}
              </figure>
              {/* <p>#CR1987876</p> */}
            </div>
            <div className="profile_info">
              <h2>
                <b>{`${data?.firstName || "-"} ${data?.lastName || ""}`}</b>
                {/* <span>
                  <StarIcon /> 5 Stars (52)
                </span> */}
              </h2>
              <ul className="text_list">
                <li>
                  <img src="/static/images/sms_icon.svg" alt="Icon" />{" "}
                  {data?.email || "-"}
                </li>
                <li>
                  <img src="/static/images/calling_icon.svg" alt="Icon" />{" "}
                  {`${data?.countryCode || ""} ${data?.phone || "-"}`}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileTop;
